// extracted by mini-css-extract-plugin
module.exports = {"navi":"ClientForm__navi--1Gdpj","form":"ClientForm__form--36wOL"};